import {IConversation, IMessageCompany, IMessageRole, IMessageUser} from './types';

export class SetSelectedConversation {
    static readonly type = '[message] set selected conversation';

    constructor(public conversation: IConversation) {
    }
}

export class SetSelectedCompany {
    static readonly type = '[message] set selected company';

    constructor(public company: IMessageCompany) {
    }
}

export class SetSelectedRole {
    static readonly type = '[message] set selected role';

    constructor(public role: IMessageRole) {
    }
}

export class SetSelectedWorker {
    static readonly type = '[message] set selected worker';

    constructor(public worker: IMessageUser) {
    }
}

export class FetchUnreadConversations {
    static readonly type = '[message] fetch Unread Conversations';

    constructor() {
    }
}

export class ReduceUnreadConversations {
    static readonly type = '[message] reduce Unread Conversations';

    constructor() {
    }
}

export class FetchLastConversations {
    static readonly type = '[message] fetch Last Conversations';

    constructor() {
    }
}
